module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAU1JREFUaEPtWTFOA0EMnPkJNGl4Ag1pqJKSlLT5QrrkG/AEJDqqpIBI8APo0+cRgy5apAjd5fbwKicfvtoer2fsW+8u4fyj8/UjEuhbweEqIGkCYApg1MLynuTsL0pIesjA3wLYkPyoi1GrgKRrAO8dFvVIct7BHpKeANx18JmSfPlt35TACsAyE/wLwKIO/JS/pFsAlQIXmXFqSWpK4BXATQVMstc+kaSU4BvJca4CkUBmWbSahQLRA61FctogSshrCf3skjuSl8YqMLlL+gRwBSB/I6sipjnlmeTatAKjc5rJ7pvmrV53WWNuB/dIoASLFoxQwMJeCd9QoASLFoxQwMJeCd9QoASLFozhKuB6mDu6dPI5TkuKaxVLYx77xpnY65k4eiB6IDHwb5vY/QOH7yemdLHl95Gv1B/kHDjDHafPwV6JGKFACRYtGN/pwfYxeruEKwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/full1.png
// module id = WZLU
// module chunks = 1